export function pushedVehicles(state) {
	if (!state.vehicles) return [];
	return state.vehicles.filter(vehicle => vehicle.pushed);
}

export function vehicleCount(state, getters, rootState) {
	return rootState.datasource.last_import_count || 0;
}

export function failedVehicles(state) {
	if (!state.vehicles) return [];
	return state.vehicles.filter(vehicle => !vehicle.pushed);
}

export function lastPushAvailable(state) {
	if (!state.history) return false;
	return (
		state.history.successCount != null
		&& state.history.failCount != null
	);
}
